// extracted by mini-css-extract-plugin
export default {"sidepanel":"sidepanel_sidepanel__ssIFR","opened":"sidepanel_opened__n6KCv","bubble":"sidepanel_bubble__ttlTV","close_btn":"sidepanel_close_btn__yM34A"};